import React from "react";
import { useDispatch } from "react-redux";
import { Box, Button, LinkButton } from "@bca/ui-library";
import styled from "styled-components";
import css from "@styled-system/css";

import ArrowDownSVG from "../Icons/ArrowDownSVG";
import TruckSvg from "../Icons/TruckSvg";
import { CLEAR_ALL } from "../redux/slices/bookDeliverySlice";
import { useViewport, Devices } from "../Hooks/useViewport.hook";
import { useGetRequestDeliveryLink } from "../Hooks/useGetRequestDeliveryLink";
import { SHOW_SNACKBAR } from "../redux/slices/snackbarSlice";
import requestMultipleDeliveriesLinkDataPush from "../AdobeDataPushes/vehicleCard/requestMultipleDeliveriesLinkDataPush";
import clearAllSelectedVehiclesDataPush from "../AdobeDataPushes/multipleDelivery/clearAllSelectedVehiclesDataPush";

const RequestDeliveryButton = styled(LinkButton)`
  white-space: nowrap;
`;

const ExpandButton = styled(Button)`
  border: 1px solid;
  border-radius: 8px;
  ${css({
    borderColor: "msg-light-blue",
  })}
`;

const MultipleDeliveryButtons = ({ isExpanded, handleSlideout }) => {
  const viewport = useViewport();
  const dispatch = useDispatch();

  const handleClearAll = () => {
    clearAllSelectedVehiclesDataPush();
    dispatch(CLEAR_ALL());
    dispatch(SHOW_SNACKBAR(false));
  };

  const multipleDeliveryAnalyticsHandler = () =>
    requestMultipleDeliveriesLinkDataPush("pop-up");

  const requestDeliveryLink = useGetRequestDeliveryLink();

  return (
    <Box display="flex" justifyContent="flex-end">
      <Button
        variant="secondary"
        icon="trash"
        iconWidth="12.25px"
        iconHeight="14px"
        fontSize="body-small"
        marginRight="20px"
        width={{ desktop: "123px", mobile: "50%" }}
        height="44px"
        paddingX={4}
        onClick={handleClearAll}
      >
        Clear all
      </Button>
      <RequestDeliveryButton
        variant="primary"
        fontSize="body-small"
        width={{ desktop: "224px", mobile: "50%" }}
        height="44px"
        paddingX={4}
        link={requestDeliveryLink}
        onClick={multipleDeliveryAnalyticsHandler}
        shouldOpenInNewWindow={false}
      >
        <TruckSvg fill="primary-white" marginRight="11px" display="flex" />
        Request Delivery
      </RequestDeliveryButton>
      {!isExpanded &&
        (viewport === Devices.DESKTOP || viewport === Devices.TABLET) && (
          <ExpandButton
            variant="secondary-white"
            padding={0}
            width="44px"
            height="44px"
            onClick={handleSlideout}
            marginLeft="20px"
          >
            <ArrowDownSVG
              height="24px"
              style={{
                transform: `rotate(${isExpanded ? "0deg" : "-180deg"})`,
                transition: "all 0.2s ease-in-out",
              }}
            />
          </ExpandButton>
        )}
    </Box>
  );
};

export default MultipleDeliveryButtons;
